
<template>
  <!-- <div id="workbench"></div> -->
  <div>

    <div class="mar-b-20 ">
      <div class="ipub-h1 line-h-40 relative mar-b-20">
        Reason for Reject Review
      </div>
      <ipub-form ref="reviews-commit1"
                 :model="reviews">
        <ipub-row :gutter="20">
          <ipub-col :span="6">
            <ipub-form-item prop="resason"
                            label="">
              <ipub-select v-model="reviews.reasonCode"
                           placeholder="Please select the reject Reseason">
                <ipub-select-option v-for="(value) in reviewRefuseList"
                                    v-show="value.enabled"
                                    :key="value.id"
                                    :value="value.code">
                  {{ value.name }}
                </ipub-select-option>
              </ipub-select>
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-textarea placeholder="Write down your reject reason in detail…"
                       v-model.trim="reviews.reason"
                       :autoSize="{ cols: '', rows: '10' }" />

        <div>
          <div class="ipub-p2 fw-bd line-h-40 relative mar-b-20 flex">
            <span>Suggest Reviewers</span>
            <div class="mar-l-20">
              <ipub-icon type="iconAdd"
                         class="link-color ipub-p2 fw-bd"></ipub-icon>
              <font class="link-color ipub-cursor-pointer ipub-p2"
                    @click="addReviewer"
                    style="margin-left:5px">Add Another Suggest</font>
            </div>

          </div>
          <!-- <ipub-row :gutter="12"
                    v-for="(item,index) in reviews.reviewerList"
                    :key="'item'+index"> -->
          <div class="flex"
               style="align-items: center;justify-content: center;"
               v-for="(item,index) in reviews.reviewerList"
               :key="'item'+index">
            <div style="width:30%">
              <ipub-form-item prop="firstName"
                              label="First Name">
                <ipub-input v-model.trim="item.firstName"
                            placeholder="First Name" />
              </ipub-form-item>
            </div>
            <div class="mar-l-16"
                 style="width:30%">
              <ipub-form-item prop="lastName"
                              label="Last Name">
                <ipub-input v-model.trim="item.lastName"
                            placeholder="Last Name" />
              </ipub-form-item>
            </div>
            <div class="mar-l-16"
                 style="width:37%">
              <ipub-form-item prop="email"
                              label="Email">
                <ipub-input v-model.trim="item.email"
                            placeholder="Email" />
              </ipub-form-item>
            </div>
            <div class="mar-l-16 ipub-cursor-pointer"
                 style="width:3%">
              <div class="flex"
                   style="align-items: center;justify-content: center;width: 100%;height: 100%;">
                <div @click="delReviewer(index)"
                     class=" del-style ipub-cursor">
                  <ipub-icon type="iconDelete"
                             style="font-size:20px"
                             class="ipub-p2"></ipub-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ipub-form>
    </div>
    <div>
      <ipub-button type="primary"
                   :style="{ minWidth: '150px' }"
                   @click="submit">Submit</ipub-button>
    </div>

  </div>
</template>



<script>
import main from './main'
export default main

</script>

<style lang="scss" scoped>
@import './main.scss';
.part {
  background: $content_color;
  padding: 24px 36px 36px;
}
.del-style {
  width: 41px;
  height: 41px;
  background: $content_color;
  border: 1px solid #e9eef0;
  opacity: 1;
  border-radius: 4px;
  line-height: 41px;
  text-align: center;
}
</style>
